import React from 'react';
import { motion } from 'framer-motion';

// 👉 Aquí pones las imágenes reales que usarás
const socialLinks = [
  {
    icon: "/images/ig.png",
    name: "Instagram",
    url: "https://www.instagram.com/juand.lacruz89?igsh=MThvZjdtajgzeWZmeA%3D%3D&utm_source=qr",
    description: "Comparte momentos mágicos y sigue nuestras historias diarias"
  },
  {
    icon: "/images/tk.png",
    name: "Tiktok",
    url: "https://vt.tiktok.com/ZSSxkdUG3/",
    description: "Disfruta de videos cortos con rituales, lecturas y consejos esotéricos"
  },
];

const Social = () => {
  return (
    <section id="socials" className="relative pt-36 pb-20 bg-[#1E0B1A] overflow-hidden">

      {/* ✦ ICONOS FLOTANTES (opcional pero estético) */}
      <motion.div 
        className="absolute top-20 left-10 text-blue-400 text-4xl opacity-20"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 4, repeat: Infinity }}
      >
        ✦
      </motion.div>

      <motion.div 
        className="absolute bottom-24 right-10 text-purple-400 text-3xl opacity-20"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 5, repeat: Infinity }}
      >
        ✧
      </motion.div>

      <div className="container mx-auto px-4 max-w-6xl relative z-[5]">

        {/* TÍTULO PRINCIPAL */}
        <motion.h2 
          className="text-4xl font-bold text-center mb-10 text-[#C9AB00]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Conéctate con Nosotros
        </motion.h2>

        {/* SUBTÍTULO MÍSTICO */}
        <motion.p 
          className="text-center text-gray-300 max-w-2xl mx-auto mb-10 text-lg"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Síguenos en nuestras redes para descubrir rituales, lecturas, promociones exclusivas 
          y mensajes energéticos diarios que elevarán tu vibración.
        </motion.p>

        {/* SEPARADOR BRILLANTE */}
        <div className="mx-auto mb-20 w-40 h-1 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full shadow-[0_0_15px_3px_rgba(89,131,252,0.7)]"></div>

        {/* TARJETA INTRODUCTORIA */}
        <motion.div 
          className="bg-white/5 border border-blue-500/20 p-8 rounded-2xl text-center mb-20 
                     max-w-2xl mx-auto shadow-xl backdrop-blur-md"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h3 className="text-2xl font-bold text-blue-300 mb-3">Energía al Alcance de un Clic</h3>
          <p className="text-gray-300 leading-relaxed">
            Conéctate a nuestras redes y recibe mensajes espirituales.
          </p>
        </motion.div>

        {/* GRID DE CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 justify-items-center">
          {socialLinks.map((social, index) => (
            <motion.a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="bg-white rounded-2xl p-8 
                         border border-[#2c223e]/20 shadow-lg 
                         hover:shadow-[0_0_25px_5px_rgba(255,0,0,0.6)]
                         transition-all duration-300 
                         text-center text-[#2c223e]
                         w-[400px]"
            >

              {/* 🔮 Aura esotérica */}
              <div className="mb-6 flex items-center justify-center relative">

                <div className="w-24 h-24 rounded-full bg-gradient-to-br 
                                from-blue-500/40 to-blue-300/20 
                                blur-xl absolute"></div>

                <img 
                  src={social.icon}
                  alt={social.name}
                  className="relative w-16 h-16 object-contain drop-shadow-md"
                />
              </div>

              <h3 className="text-xl font-semibold mb-4 text-[#825d99]">
                {social.name}
              </h3>

              <p className="text-[#2c223e] leading-relaxed">
                {social.description}
              </p>

            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Social;
